import { EMPTY_DOLLAR } from "../../../../../../../shared/typeahead-prefill";

export const DEFAULT_MEASUREMENT = {
    value: "",
    uom: { ...EMPTY_DOLLAR },
};

export const DEFAULT_RANGE = {
    sliderTitle: "",
    selectedValue: [],
    label: "Cost Range of Similar Models",
    labelRange: "",
    low: { ...EMPTY_DOLLAR },
    high: { ...EMPTY_DOLLAR },
    legendText: "",
};

export const DEFAULT_SINGLE_VALUE = {
    sliderTitle: "",
    selectedValue: [],
    label: "",
    labelRange: "",
    low: null,
    high: null,
    legendText: "",
};
